module.exports = __webpack_public_path__ + "static/media/AdobeSign_Step4_Image29.545ed963.jpg";